import React, { Component } from "react";
import { Message, Container } from "semantic-ui-react";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";

export default class WelcomePage extends Component {
  render() {
    return (
      <Container
        id="welcome-container"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
        }}
      >
        <Message
          positive
          size="large"
          style={{
            textAlign: "center",
            fontSize: "1.2rem",
            lineHeight: "1.8",
            maxWidth: "800px",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            Welcome, {this.props.userName}!
          </div>
          We are excited to have you at SimplyStock.Net, your trusted platform
          for simplified stock analysis. Explore a wide range of investment
          ideas and insights on stocks and ETFs traded on major US exchanges.
          <br />
          <br />
          Before you begin, please review our{" "}
          <a
            title="Terms & Conditions"
            href="./TC.html"
            rel="noopener noreferrer"
            target="_blank"
            style={{ color: "#4183c4", textDecoration: "underline" }}
          >
            Terms & Conditions
          </a>
          .
          <br />
          <br />
          We value your feedback! Use the "Submit Feature" link to share your
          thoughts or report any issues.
        </Message>
      </Container>
    );
  }
}
